import React, { createContext } from "react";
import { defaultLanguage } from "src/utils/localization/languages/languages";
import { Language } from "src/utils/localization/languages/types";
import { Helmet } from "react-helmet";

// Lingui doesn't give access to the language, so we need our own provider
// to pass it down to child components
export const LanguageContext = createContext<Language>(
  defaultLanguage as Language
);

export interface I18nProviderProps {
  language?: Language;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({
  language = defaultLanguage as Language,
  children
}) => {
  return (
    <LanguageContext.Provider value={language}>
      <Helmet htmlAttributes={{ lang: language.ogLang }} />
      {children}
    </LanguageContext.Provider>
  );
};

export function useLanguage(): Language {
  return React.useContext(LanguageContext);
}
